import { getArrayFromStorage, saveArrayToStorage } from '../utils';
export class AddToFavourite {
    button;
    id;
    constructor(button) {
        this.button = button;
        this.id = Number(button.getAttribute('data-wishlist'));
        const handleClick = this.handleClick.bind(this);
        this.button.addEventListener('click', handleClick);
        const wishlist = getArrayFromStorage('scrimWishlist');
        const parent = this.button.closest('article');
        if (wishlist.includes(this.id)) {
            this.button.classList.add('is-active');
            parent?.classList.add('in-wishlist');
        }
    }
    handleClick(e) {
        e.stopPropagation();
        e.preventDefault();
        if (this.id) {
            const wishlist = getArrayFromStorage('scrimWishlist');
            const parent = this.button.closest('article');
            if (wishlist.includes(this.id)) {
                // Removes items
                const w = wishlist.filter((item) => this.id !== item);
                saveArrayToStorage('scrimWishlist', w);
                this.button.classList.remove('is-active');
                parent?.classList.remove('in-wishlist');
            }
            else {
                // Adds items
                saveArrayToStorage('scrimWishlist', [...wishlist, this.id]);
                this.button.classList.add('is-active');
                parent?.classList.add('in-wishlist');
            }
        }
    }
}
